// tslint:disable:no-require-imports no-var-requires
import * as React from 'react';
import { addLocaleData, IntlProvider, Locale } from 'react-intl';
import settingsStore from './../services/settings/settings-store';
/************************************************************
*****************************************************************************
*************************/
/****************************************************/
import { RostelecomAuthRoot } from './customers/rostelecom/layout/root/rostelecom-auth-root';
/************************/
/*********************************
************************************************************************
**************************************************************
*************************/
/*****************************************
************************************************************************
*************************/

addLocaleData(require('react-intl/locale-data/en') as Locale);
addLocaleData(require('react-intl/locale-data/ru') as Locale);

export class AuthContainer extends React.Component<{}, {}> {
    public render(): React.ReactNode {
        const locale = settingsStore.getLocale();
        const messages = settingsStore.getI18nMessages();
        return (
            <IntlProvider locale={locale} messages={messages}>
                {/*************************************************************
***********************************
******************************************/}
                {/****************************************************/}
                <RostelecomAuthRoot />
                {/************************/}
                {/**********************************
*******************************
******************************************/}
                {/******************************************
*******************************
******************************************/}
            </IntlProvider>
        );
    }
}
